import React, { useState } from 'react';

function SensiboAuth({ saveCredentials }) {
  const [apiKey, setApiKey] = useState('');
  const [saveStatus, setSaveStatus] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    // Check if API key is provided
    if (!apiKey.trim()) {
      alert('Please enter an API key');
      return;
    }

    setIsSaving(true);
    setSaveStatus('Saving...');

    const result = await saveCredentials('sensibo_credentials', {
      api_key: apiKey
    });

    setSaveStatus(result.message);

    if (result.success) {
      // Clear the form after successful save
      setTimeout(() => {
        setApiKey('');
        setSaveStatus('');
      }, 2000);
    } else {
      setTimeout(() => setSaveStatus(''), 3000);
    }

    setIsSaving(false);
  };

  return (
    <div className="provider-card">
      <h3 className="provider-title">Sensibo</h3>
      <div className="input-group">
        <label htmlFor="sensibo_apiKey" className="input-label">
          API Key
        </label>
        <input
          id="sensibo_apiKey"
          type="text"
          className="input-field"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="Enter your Sensibo API key"
        />
      </div>
      <button
        onClick={handleSave}
        className="auth-button"
        disabled={isSaving}
      >
        {isSaving ? 'Saving...' : 'Save'}
      </button>
      {saveStatus && (
        <div className={`save-status ${saveStatus.includes('Error') ? 'error' : 'success'}`}>
          {saveStatus}
        </div>
      )}
    </div>
  );
}

export default SensiboAuth;
